import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        style: {
          background: '#161616',
          border: '0.5px solid rgba(255,255,255,0.10)',
          borderRadius: '10px',
          color: '#F0EFE8',
          fontFamily: 'var(--orbis-font)',
          fontSize: '13px',
          fontWeight: 300,
          boxShadow: 'none',
        },
        classNames: {
          description: 'group-[.toast]:text-[#8A8882]',
          actionButton: 'group-[.toast]:bg-[#B8CCDF] group-[.toast]:text-[#0E0E0E]',
          cancelButton: 'group-[.toast]:bg-[#1E1E1E] group-[.toast]:text-[#8A8882]',
          success: 'group-[.toast]:text-[#8FC4A0]',
          error: 'group-[.toast]:text-[#E07070]',
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast }
